// JS multiplication of floats can give unexpected results. For instance, 0.07 * 100 returns 7.000000000000001
// Therefore, we use this util to perform safe multiplication of floating point numbers
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function safeMultiply(
  multiplicand?: number | null,
  multiplier?: number | null,
  nanValue = null,
) {
  if (typeof multiplicand !== 'number' || typeof multiplier !== 'number') {
    return nanValue;
  }

  return Number((multiplicand * multiplier).toFixed(10));
}
